// import { supabase } from './supabase';
// import { State, Board, Class, UserPreferences, PersonalizationFormData } from '@/types/personalization';

import {
  State,
  Board,
  Class,
  UserPreferences,
  PersonalizationFormData,
} from "../types/auth.types";

export const personalizationService = {
  async getStates(): Promise<State[]> {
    const data = null;
    // const { data, error } = await supabase
    //   .from('states')
    //   .select('*')
    //   .order('name');

    // if (error) throw error;
    return data || [];
  },

  async getBoards(): Promise<Board[]> {
    const data = null;
    // const { data, error } = await supabase
    //   .from('boards')
    //   .select('*')
    //   .order('name');

    // if (error) throw error;
    return data || [];
  },

  async getClasses(): Promise<Class[]> {
    const data = null;

    // const { data, error } = await supabase
    //   .from('classes')
    //   .select('*')
    //   .order('level');

    // if (error) throw error;
    return data || [];
  },

  async getUserPreferences(_userId: string): Promise<UserPreferences | null> {
    // const { data, error } = await supabase
    //   .from('user_preferences')
    //   .select('*')
    //   .eq('user_id', userId)
    //   .maybeSingle();

    // if (error) throw error;
    return null;
  },

  async createUserPreferences(
    _userId: string,
    _preferences: PersonalizationFormData,
  ): Promise<UserPreferences | null> {
    // const { data, error } = await supabase
    //   .from('user_preferences')
    //   .insert({
    //     user_id: userId,
    //     full_name: preferences.fullName,
    //     state_id: preferences.stateId,
    //     board_id: preferences.boardId,
    //     class_id: preferences.classId,
    //     preferred_language: preferences.preferredLanguage,
    //   })
    //   .select()
    //   .single();

    // if (error) throw error;
    return null;
  },

  async updateUserPreferences(
    _userId: string,
    _preferences: PersonalizationFormData,
  ): Promise<UserPreferences | null> {
    // const { data, error } = await supabase
    //   .from('user_preferences')
    //   .update({
    //     full_name: preferences.fullName,
    //     state_id: preferences.stateId,
    //     board_id: preferences.boardId,
    //     class_id: preferences.classId,
    //     preferred_language: preferences.preferredLanguage,
    //     updated_at: new Date().toISOString(),
    //   })
    //   .eq('user_id', userId)
    //   .select()
    //   .single();

    // if (error) throw error;
    return null;
  },
};
